import request from '@/utils/request'

export function getUserSealInfoApi() {  // 获取个人签章列表
  return request({
    url: '/sealInfo/user?nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function deleteSealApi(data) { // 删除印章
  return request({
    url: '/sealInfo/remove',
    method: 'post',
    data
  })
}

export function setDefaultSealApi(data) { // 设置默认章
  return request({
    url: '/sealInfo/setCurrent',
    method: 'post',
    data
  })
}

export function getCompanyAuthSealInfoApi(data) { // 查询可用章
  return request({
    url: '/sealInfo/use?companyId='+data.companyId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function uploadSealApi(data) { // 上传签章
  return request({
    url: '/sealInfo/add',
    method: 'post',
    data
  })
}

export function getCompanySealInfoApi(data) { // 查询所有章
  return request({
    url: '/sealInfo/company?companyId='+data.companyId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function applyUseApi(data) { // 申请用章
  return request({
    url: '/sealInfo/initMessage',
    method: 'post',
    data
  })
}

export function deleteMessageApi(data) {  // 删除签章
  return request({
    url: '/sealInfo/deleteMessage',
    method: 'post',
    data
  })
}

export function getDrawCodeApi() {
  return request({
    url: '/sealInfo/getQRCode?nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function ressetSealNameApi(data) {
  return request({
    url: '/sealInfo/modifySealName',
    method: 'post',
    data
  })
}

export function getlistUnauthorizedApi(data) {
  return request({
    url: '/sealInfo/listUnauthorized?userId='+data.userId+'&companyId='+data.companyId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}
